import { useParams, useSearchParams } from "react-router-dom";
import { useForm } from "react-hook-form";
import { MdOutlineEmail } from "react-icons/md";

import AuthLayout from "@/layouts/Auth/AuthLayout";
import Input from "@/components/input/Input";
import Button from "@/components/Button";
import { useResetPassword } from "../hooks/useResetPassword";

function ResetPasswordForm() {
    const { register, formState, handleSubmit, getValues } = useForm();
    const { errors } = formState;

    const { isPending, resetPassword, error: ApiError } = useResetPassword();

    const { token } = useParams();

    const [searchParams] = useSearchParams();
    const email = searchParams.get("email");

    function onSubmit(data) {
        const { email, password, password_confirmation } = data;

        resetPassword({ token, email, password, password_confirmation });
    }

    return (
        <AuthLayout
            title="تغيير كلمه السر"
            description="ادخل كلمة السر الجديده"
        >
            <form className="w-4/5" onSubmit={handleSubmit(onSubmit)}>
                {/* Email */}
                <Input
                    className="py-2"
                    type="email"
                    name="email"
                    label="البريد الإلكتروني*"
                    defaultValue={email}
                    icon={MdOutlineEmail}
                    register={register("email", {
                        required: "هذه الخانة مطلوبه",
                        pattern: {
                            value: /\S+@\S+\.\S+/,
                            message: "يرجى كتابة عنوان بريد إلكتروني صالح",
                        },
                    })}
                    error={
                        errors?.email?.message ||
                        ApiError?.response?.data?.errors?.email?.[0]
                    }
                />

                {/* Password */}
                <Input
                    className="py-2"
                    label="كلمة السر"
                    name="password"
                    type="password"
                    disabled={isPending}
                    error={
                        errors?.password?.message ||
                        ApiError?.response?.data?.errors?.password?.[0]
                    }
                    register={register("password", {
                        required: "هذه الخانة مطلوبه",
                        pattern: {
                            value: /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d\W]{8,}/,
                            message:
                                "يجب أن تكون كلمة المرور الخاصة بك 8 أحرف على الأقل وأن تحتوي على أحرف وأرقام.",
                        },
                    })}
                />

                {/* PasswordConfirmaion */}
                <Input
                    className="py-2"
                    label="تأكيد كلمة السر"
                    disabled={isPending}
                    type="password"
                    name="password_confirmation"
                    error={
                        errors?.password_confirmation?.message ||
                        ApiError?.response?.data?.errors
                            ?.password_confirmation?.[0]
                    }
                    register={register("password_confirmation", {
                        required: "هذه الخانة مطلوبه",
                        validate: {
                            validate: (value) =>
                                value !== getValues().password
                                    ? "كلمة المرور وتأكيد كلمة المرور غير متطابقين."
                                    : true,
                        },
                    })}
                />
                <div className="w-full py-3">
                    <Button
                        type="primary"
                        className="w-full leading-8"
                        disabled={isPending}
                    >
                        تسجيل
                    </Button>
                </div>
            </form>
        </AuthLayout>
    );
}

export default ResetPasswordForm;
